import Section from "components/molecules/SectionTracker";
import Footer from "components/organisms/Footer";
import About from "./Home/About";
import Projects from "./Home/Projects";
import Skills from "./Home/Skills";
import Contact from "./Home/Contact";

const Portfolio = () => {
  return (
    <div className="w-full" style={{ background: "var(--site-bg)", color: "var(--site-text)" }}>
      <Section id={"About Me"} children={<About />} addedStyle="group w-full min-h-screen text-center flex justify-center items-center py-32 mobile:py-20" />
      <Section id={"Projects"} children={<Projects />} addedStyle="group w-full min-h-screen text-center flex flex-col gap-6 justify-start items-center py-32 mobile:py-20" />
      <Section id={"Skills"} children={<Skills />} addedStyle="group w-full min-h-screen text-center flex flex-col gap-6 justify-start items-center py-32 mobile:py-20" />
      <Section id={"Contact"} children={<Contact />} addedStyle="group w-full h-fit min-h-screen flex justify-center items-center py-32 mobile:py-20" />
      <Section id={"My Resume"} children={<Footer />} addedStyle="group w-full h-fit min-h-screen flex justify-center items-center" />
    </div>
  );
};

export default Portfolio;
